import { atom, RecoilRoot } from "recoil";

export const dataState = atom({
  key: "dataState", // Unique ID for the atom
  default: null,    // Default value
});
export const doctorProfileRequestState = atom({
  key: "doctorProfileRequestState", // Unique ID for the atom
  default: null,    // Default value
});

export default RecoilRoot;